/* ============================================================================
   PJ Side Cart — drawer global do tema [QUIZ V2] Proper Jack.
   Substitui o cart drawer antigo (cart-ajax.js + side-drawer.liquid). Funciona
   em todas as páginas do tema. Checkout vai pro Yampi via api.dooki.com.br.

   Exposto em window.pjSideCart = { open, close, addItem, load }.
   Intercepta clicks no .cart-icon / .openCartDrawer pra abrir o nosso drawer.
   v2.1 — pre-warm Yampi checkout URL + fast path + fire-and-forget cart clear.
   ============================================================================ */
(function () {
  'use strict';

  var FREE_SHIPPING_CENTS = 20000; // R$ 200,00
  var YAMPI_CART_ENDPOINT = 'https://api.dooki.com.br/v2/public/shopify/cart';
  var CART_CACHE_MS = 5000; // 5s — evita refetch consecutivo do /cart.js
  var CHECKOUT_PREWARM_TTL_MS = 90000; // 90s — TTL do checkout_direct_url cacheado
  var state = { data: null, fetchedAt: 0 };
  // Cache do checkout_direct_url do Yampi. Chave = hash do estado do cart.
  // Permite "pre-warm": ao abrir o drawer, disparamos o POST pro Yampi em
  // background; quando user clica em checkout, URL já tá pronto → redirect
  // quase instantâneo (~50ms vs 800-2000ms anterior).
  var checkoutCache = { url: null, cartKey: null, warmedAt: 0, inflight: false };

  function cartKey(data) {
    if (!data || !data.items || !data.items.length) return '';
    var parts = [];
    for (var i = 0; i < data.items.length; i++) {
      parts.push(data.items[i].key + ':' + data.items[i].quantity);
    }
    return data.item_count + '|' + data.total_price + '|' + parts.join(',');
  }

  function warmCheckout() {
    if (!state.data || !state.data.items || state.data.items.length === 0) return;
    if (checkoutCache.inflight) return;
    var key = cartKey(state.data);
    if (checkoutCache.url
        && checkoutCache.cartKey === key
        && (Date.now() - checkoutCache.warmedAt) < CHECKOUT_PREWARM_TTL_MS) {
      return; // cache válido — nada a fazer
    }
    checkoutCache.inflight = true;
    var payload = {
      shop: window.location.host,
      shopify_internal_domain: (window.Shopify && window.Shopify.shop) || 'properjack.myshopify.com',
      cart_payload: state.data
    };
    var opts = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    };
    try { opts.priority = 'low'; } catch (_) {}
    fetch(YAMPI_CART_ENDPOINT, opts)
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        if (resp && resp.checkout_direct_url) {
          checkoutCache.url = resp.checkout_direct_url;
          checkoutCache.cartKey = key;
          checkoutCache.warmedAt = Date.now();
        }
      })
      .catch(function () { /* slow path no checkoutYampi cobre */ })
      .then(function () { checkoutCache.inflight = false; });
  }

  function getRoot() { return document.getElementById('pj-sc'); }
  function $(sel) {
    var r = getRoot();
    return r ? r.querySelector(sel) : null;
  }
  function $$(sel) {
    var r = getRoot();
    return r ? r.querySelectorAll(sel) : [];
  }
  function fmt(cents) {
    if (typeof cents !== 'number') return '0,00';
    return (cents / 100).toFixed(2).replace('.', ',');
  }
  function esc(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  function open() {
    var root = getRoot();
    if (!root) return;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    load();
  }
  function close() {
    var root = getRoot();
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function load(force) {
    // Cache de 5s: evita refetch quando user abre/fecha o drawer rapidamente.
    // Mutações (changeQty, addItem) invalidam manualmente via state.fetchedAt = 0.
    if (!force && state.data && (Date.now() - state.fetchedAt) < CART_CACHE_MS) {
      render();
      warmCheckout();
      return Promise.resolve(state.data);
    }
    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      state.data = data;
      state.fetchedAt = Date.now();
      render();
      warmCheckout();
      return data;
    })
    .catch(function (err) { console.error('[pj-sc] load:', err); });
  }

  function render() {
    renderItems();
    renderSubtotal();
    renderFreight();
  }

  function renderItems() {
    var itemsEl = $('[data-sc-items]');
    var emptyEl = $('[data-sc-empty]');
    var checkoutBtn = $('[data-sc-checkout]');
    if (!itemsEl || !emptyEl) return;
    var data = state.data;
    if (!data || !data.items || data.items.length === 0) {
      itemsEl.innerHTML = '';
      emptyEl.removeAttribute('hidden');
      if (checkoutBtn) checkoutBtn.disabled = true;
      return;
    }
    emptyEl.setAttribute('hidden', '');
    if (checkoutBtn) checkoutBtn.disabled = false;
    var trashSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>';
    var html = data.items.map(function (item) {
      var img = item.image || item.featured_image || '';
      var variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? esc(item.variant_title) : '';
      return '<li class="pj-sc-item" data-key="' + esc(item.key) + '">' +
        (img ? '<img class="pj-sc-item-img" src="' + esc(img) + '" alt="">' : '<div class="pj-sc-item-img"></div>') +
        '<div class="pj-sc-item-info">' +
          '<strong class="pj-sc-item-title">' + esc(item.product_title || '') + '</strong>' +
          (variantTitle ? '<span class="pj-sc-item-variant">' + variantTitle + '</span>' : '') +
          '<div class="pj-sc-item-qty">' +
            '<button type="button" data-sc-qty="dec" aria-label="Reduzir">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-sc-qty="inc" aria-label="Aumentar">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="pj-sc-item-side">' +
          '<button type="button" class="pj-sc-item-remove" data-sc-remove aria-label="Remover item">' + trashSvg + '</button>' +
          '<strong class="pj-sc-item-price">R$ ' + fmt(item.final_line_price) + '</strong>' +
        '</div>' +
      '</li>';
    }).join('');
    itemsEl.innerHTML = html;
  }

  function renderSubtotal() {
    var el = $('[data-sc-subtotal]');
    var pixEl = $('[data-sc-pix-value]');
    var total = (state.data && state.data.total_price) || 0;
    if (el) el.textContent = 'R$ ' + fmt(total);
    // Preço no PIX: 2% off. Math.round trabalha em cents (total_price já é cents).
    if (pixEl) pixEl.textContent = 'R$ ' + fmt(Math.round(total * 0.98));
  }

  function renderFreight() {
    var freightEl = $('[data-sc-freight]');
    var textEl = $('[data-sc-freight-text]');
    var fillEl = $('[data-sc-freight-fill]');
    if (!textEl || !fillEl || !freightEl) return;
    var total = (state.data && state.data.total_price) || 0;
    if (total >= FREE_SHIPPING_CENTS) {
      freightEl.classList.add('is-free');
      textEl.innerHTML = '🔥 Esse frete é por <strong>nossa conta</strong>';
      fillEl.style.width = '100%';
    } else {
      freightEl.classList.remove('is-free');
      var diff = FREE_SHIPPING_CENTS - total;
      var pct = (total / FREE_SHIPPING_CENTS) * 100;
      textEl.innerHTML = 'Faltam <strong>R$ ' + fmt(diff) + '</strong> para frete grátis';
      fillEl.style.width = pct + '%';
    }
  }

  function changeQty(itemKey, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: itemKey, quantity: qty }),
      credentials: 'same-origin'
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      state.data = data;
      state.fetchedAt = Date.now();
      render();
      warmCheckout(); // cart mudou → re-aquece URL pro novo estado
    })
    .catch(function (err) { console.error('[pj-sc] change:', err); });
  }

  function addItem(variantId, quantity) {
    var payload = { items: [{ id: parseInt(variantId, 10), quantity: quantity || 1 }] };
    console.log('[pj-sc] /cart/add.js payload:', payload);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload),
      credentials: 'same-origin'
    })
    .then(function (r) {
      console.log('[pj-sc] /cart/add.js status:', r.status);
      return r.text().then(function (txt) {
        if (!r.ok) {
          console.error('[pj-sc] /cart/add.js error body:', txt);
          var msg;
          try { var j = JSON.parse(txt); msg = j.description || j.message || ('add_failed_' + r.status); }
          catch (_) { msg = 'add_failed_' + r.status; }
          throw new Error(msg);
        }
        return JSON.parse(txt);
      });
    })
    .then(function () {
      state.fetchedAt = 0; // força refetch após add
      return load(true);
    });
  }

  /* CEP calculator. Busca UF via ViaCEP (necessário pra Shopify processar BR),
     manda pro /cart/prepare_shipping_rates, polling em /cart/async_shipping_rates.
     Se 422 persistir, fallback pro endpoint síncrono /cart/shipping_rates.json. */
  function loadShippingRates(zip) {
    var ratesEl = $('[data-sc-rates]');
    if (!ratesEl) return Promise.resolve();
    ratesEl.removeAttribute('hidden');
    ratesEl.innerHTML = '<span class="pj-sc-rates-loading">Calculando frete...</span>';

    return fetch('https://viacep.com.br/ws/' + zip + '/json/')
      .then(function (r) { return r.json(); })
      .then(function (cepData) {
        console.log('[pj-sc] ViaCEP resp:', cepData);
        if (cepData.erro) throw new Error('CEP não encontrado');
        var province = cepData.uf || '';
        var city = cepData.localidade || '';
        var body = 'shipping_address[zip]=' + encodeURIComponent(zip) +
                   '&shipping_address[country]=BR' +
                   '&shipping_address[province]=' + encodeURIComponent(province) +
                   '&shipping_address[city]=' + encodeURIComponent(city);
        return fetch('/cart/prepare_shipping_rates', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'X-Requested-With': 'XMLHttpRequest' },
          body: body,
          credentials: 'same-origin'
        })
        .then(function (r) {
          console.log('[pj-sc] prepare status:', r.status);
          return r.text();
        })
        .then(function (txt) {
          console.log('[pj-sc] prepare body returned:', txt || '(empty)');
          if (txt) {
            try {
              var parsed = JSON.parse(txt);
              if (parsed && parsed.zip) throw new Error(parsed.zip[0] || 'CEP inválido');
              if (parsed && parsed.province) throw new Error('Estado inválido pro CEP');
              if (parsed && parsed.error) throw new Error(parsed.error);
            } catch (e) {
              if (!(e instanceof SyntaxError)) throw e;
            }
          }
          var attempts = 0;
          function tryFetch() {
            attempts++;
            return fetch('/cart/async_shipping_rates', {
              headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              credentials: 'same-origin'
            })
            .then(function (rr) {
              console.log('[pj-sc] async status (attempt ' + attempts + '):', rr.status);
              if (rr.status === 422) {
                return rr.text().then(function (t) {
                  console.error('[pj-sc] async 422 body:', t);
                  throw new Error('async_422');
                });
              }
              return rr.json();
            })
            .then(function (resp) {
              console.log('[pj-sc] async resp (attempt ' + attempts + '):', resp);
              if (!resp || resp.shipping_rates == null) {
                if (attempts < 8) {
                  return new Promise(function (res) { setTimeout(res, 700); }).then(tryFetch);
                }
                return { shipping_rates: [], _gaveUp: true };
              }
              return resp;
            });
          }
          return tryFetch().catch(function (err) {
            if (err.message === 'async_422') {
              console.log('[pj-sc] fallback /cart/shipping_rates.json');
              var qs = '?shipping_address[zip]=' + encodeURIComponent(zip) +
                       '&shipping_address[country]=BR' +
                       '&shipping_address[province]=' + encodeURIComponent(province);
              return fetch('/cart/shipping_rates.json' + qs, {
                headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                credentials: 'same-origin'
              })
              .then(function (rrr) {
                console.log('[pj-sc] shipping_rates.json status:', rrr.status);
                return rrr.json();
              })
              .then(function (jj) {
                console.log('[pj-sc] shipping_rates.json resp:', jj);
                return { shipping_rates: jj.shipping_rates || [] };
              });
            }
            throw err;
          });
        });
      })
      .then(function (resp) {
        var rates = (resp && resp.shipping_rates) || [];
        if (!rates.length) {
          var hint = resp && resp._gaveUp
            ? 'Shopify não retornou taxas. Verifique zonas de entrega.'
            : 'Sem taxas pra esse CEP.';
          ratesEl.innerHTML = '<span class="pj-sc-rates-error">' + hint + '</span>';
          return;
        }
        function toCents(price) {
          if (typeof price === 'number') return price > 100 ? price : Math.round(price * 100);
          if (typeof price === 'string') {
            var clean = price.replace(/[^\d.,]/g, '').replace(',', '.');
            var n = parseFloat(clean);
            return isNaN(n) ? 0 : Math.round(n * 100);
          }
          return 0;
        }
        // Extrai o prazo de entrega: tenta delivery_days[0] (pode ser 0 = mesmo dia/amanhã),
        // depois delivery_range, ISO dates, e por último número no nome. Retorna null se nada.
        function getDeliveryDays(rate) {
          if (rate.delivery_days && rate.delivery_days.length) {
            var d = rate.delivery_days[0];
            if (typeof d === 'number') return d;
            var n = parseInt(d, 10);
            if (!isNaN(n)) return n;
          }
          if (rate.delivery_range && rate.delivery_range.length) {
            var last = rate.delivery_range[rate.delivery_range.length - 1];
            var nn = parseInt(last, 10);
            if (!isNaN(nn)) return nn;
          }
          var iso = rate.max_delivery_date || rate.min_delivery_date;
          if (iso) {
            try {
              var end = new Date(iso);
              var now = new Date();
              var diff = Math.ceil((end - now) / (1000 * 60 * 60 * 24));
              if (diff >= 0 && diff < 90) return diff;
            } catch (_) {}
          }
          var m = (rate.name || '').match(/(\d+)\s*(dia|day)/i);
          if (m) return parseInt(m[1], 10);
          return null;
        }
        function formatDeliveryDays(days) {
          if (days === null) return '';
          if (days === 0) return 'Amanhã';
          if (days === 1) return '1 dia útil';
          return days + ' dias úteis';
        }
        var html = '<ul>' + rates.map(function (rate) {
          console.log('[pj-sc] rate detail:', rate);
          var cents = toCents(rate.price);
          var priceStr = cents === 0
            ? '<span class="pj-sc-rate-free">Grátis</span>'
            : '<span class="pj-sc-rate-price">R$ ' + fmt(cents) + '</span>';
          var daysText = formatDeliveryDays(getDeliveryDays(rate));
          return '<li>' +
            '<div><div class="pj-sc-rate-name">' + esc(rate.name || rate.presentment_name || '') + '</div>' +
            (daysText ? '<div class="pj-sc-rate-meta">' + daysText + '</div>' : '') +
            '</div>' + priceStr + '</li>';
        }).join('') + '</ul>';
        ratesEl.innerHTML = html;
      })
      .catch(function (err) {
        console.error('[pj-sc] shipping rates error:', err);
        ratesEl.innerHTML = '<span class="pj-sc-rates-error">' + (err.message || 'Erro ao calcular o frete.') + '</span>';
      });
  }

  /* Checkout Yampi — fluxo otimizado:
     FAST PATH (cache hit): URL já pré-aquecida via warmCheckout() ao abrir o
       drawer / mudar cart. Redirect imediato (~50ms total).
     SLOW PATH (cache miss): POST pro Yampi inline. Usa state.data se fresco
       (skip /cart.json). Cart clear é fire-and-forget com keepalive (não
       bloqueia redirect; browser garante envio mesmo após nav).
     Antes: 4 requests sequenciais ~800-2000ms. Agora: cache hit ~50ms, miss
     ~500-1200ms (sem o cart.json + sem await do clear). */
  function checkoutYampi() {
    var btn = $('[data-sc-checkout]');
    if (!btn || btn.disabled) return;
    btn.classList.add('is-loading');
    btn.disabled = true;

    function fireAndForgetClear() {
      try {
        // keepalive=true: garante que o request completa mesmo se o browser
        // navegar pra checkout antes do response chegar.
        fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          credentials: 'same-origin',
          keepalive: true
        }).catch(function () {});
      } catch (_) {}
    }
    function doRedirect(url) {
      if (typeof window.ymp_getUrlWithUtms === 'function') {
        url = window.ymp_getUrlWithUtms(url);
      }
      // PostHog: pj_quiz_begin_checkout — só dispara se o user veio do quiz
      // (state.completedAt != null no localStorage). PostHog SDK usa fetch
      // keepalive automaticamente, então o evento sobrevive ao navigate.
      try {
        var raw = localStorage.getItem('proper_diagnostic_state');
        if (raw && window.posthog && typeof window.posthog.capture === 'function') {
          var st = JSON.parse(raw);
          if (st && st.completedAt) {
            window.posthog.capture('pj_quiz_begin_checkout', {
              currency: 'BRL',
              destination: 'yampi',
              mode: 'unica',
              dor_principal: (st.answers && st.answers.principalDor) || ''
            });
          }
        }
      } catch (_) {}
      fireAndForgetClear();
      window.location.href = url;
    }

    // FAST PATH — URL cacheada pro estado atual do cart
    if (state.data) {
      var key = cartKey(state.data);
      if (checkoutCache.url
          && checkoutCache.cartKey === key
          && (Date.now() - checkoutCache.warmedAt) < CHECKOUT_PREWARM_TTL_MS) {
        doRedirect(checkoutCache.url);
        return;
      }
    }

    // SLOW PATH — usa state.data se já temos, senão fetch /cart.json
    var cartPromise = state.data
      ? Promise.resolve(state.data)
      : fetch('/cart.json', { credentials: 'same-origin' }).then(function (r) { return r.json(); });

    return cartPromise
      .then(function (cartPayload) {
        var payload = {
          shop: window.location.host,
          shopify_internal_domain: (window.Shopify && window.Shopify.shop) || 'properjack.myshopify.com',
          cart_payload: cartPayload
        };
        return fetch(YAMPI_CART_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        if (!resp || !resp.checkout_direct_url) throw new Error('no_checkout_url');
        doRedirect(resp.checkout_direct_url);
      })
      .catch(function (err) {
        console.error('[pj-sc] Yampi checkout:', err);
        btn.classList.remove('is-loading');
        btn.disabled = false;
        window.location.href = '/cart';
      });
  }

  function wire() {
    var root = getRoot();
    if (!root) return;

    // Close via backdrop/X/[data-sc-close]
    root.addEventListener('click', function (e) {
      var t = e.target;
      while (t && t !== root) {
        if (t.hasAttribute && t.hasAttribute('data-sc-close')) { e.preventDefault(); close(); return; }
        t = t.parentElement;
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    // Delegated: qty +/-, remove, upsell
    root.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest && e.target.closest('[data-sc-qty]');
      if (qtyBtn) {
        e.preventDefault(); e.stopPropagation();
        var item = qtyBtn.closest('.pj-sc-item');
        if (!item) return;
        var key = item.dataset.key;
        var current = parseInt(item.querySelector('.pj-sc-item-qty span').textContent, 10) || 1;
        var newQty = qtyBtn.dataset.scQty === 'inc' ? current + 1 : Math.max(0, current - 1);
        changeQty(key, newQty);
        return;
      }
      var removeBtn = e.target.closest && e.target.closest('[data-sc-remove]');
      if (removeBtn) {
        e.preventDefault(); e.stopPropagation();
        var item2 = removeBtn.closest('.pj-sc-item');
        if (!item2) return;
        changeQty(item2.dataset.key, 0);
        return;
      }
      var upsellBtn = e.target.closest && e.target.closest('[data-sc-upsell-add]');
      if (upsellBtn) {
        e.preventDefault(); e.stopPropagation();
        var vid = upsellBtn.getAttribute('data-sc-upsell-add');
        if (!vid) return;
        upsellBtn.disabled = true;
        addItem(vid, 1)
          .then(function () { upsellBtn.disabled = false; })
          .catch(function (err) {
            console.error('[pj-sc] upsell add failed:', err);
            upsellBtn.disabled = false;
          });
        return;
      }
    });

    // CEP
    var zipInput = $('#pj-sc-zip');
    if (zipInput) {
      zipInput.addEventListener('input', function () {
        var v = zipInput.value.replace(/\D/g, '').slice(0, 8);
        if (v.length > 5) v = v.slice(0, 5) + '-' + v.slice(5);
        zipInput.value = v;
      });
      zipInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var btn = $('[data-sc-cep-go]');
          if (btn) btn.click();
        }
      });
    }
    var cepBtn = $('[data-sc-cep-go]');
    if (cepBtn) {
      cepBtn.addEventListener('click', function () {
        var zip = (zipInput && zipInput.value || '').replace(/\D/g, '');
        if (zip.length !== 8) {
          var rates = $('[data-sc-rates]');
          if (rates) { rates.removeAttribute('hidden'); rates.innerHTML = '<span class="pj-sc-rates-error">CEP inválido.</span>'; }
          return;
        }
        cepBtn.disabled = true;
        var p = loadShippingRates(zip);
        if (p && p.finally) p.finally(function () { cepBtn.disabled = false; });
        else if (p && p.then) p.then(function () { cepBtn.disabled = false; }, function () { cepBtn.disabled = false; });
      });
    }

    // Checkout
    var checkoutBtn = $('[data-sc-checkout]');
    if (checkoutBtn) checkoutBtn.addEventListener('click', checkoutYampi);
  }

  /* Intercepta cliques no ícone de cart do header pra abrir o NOSSO drawer.
     Capture phase no document pra rodar antes do cart-ajax.js (que usa jQuery
     delegado no body em bubble phase). Cobre múltiplos seletores pra resiliência
     em diferentes headers/breakpoints. Também esconde o drawer antigo se ele abrir. */
  var CART_SELECTORS = [
    '.cart-icon',
    '.openCartDrawer',
    '[data-cart-toggle]',
    '[data-cart-drawer-toggle]',
    '.cart-link',
    '.cart-btn',
    '.header-cart',
    '.wrapper-top-cart a',
    'a[href="#cart"]',
    '[aria-label="' + 'Carrinho' + '"]',
    '[aria-label="' + 'Cart' + '"]'
  ];
  function interceptCartIcons() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var icon = null;
      for (var i = 0; i < CART_SELECTORS.length; i++) {
        icon = e.target.closest(CART_SELECTORS[i]);
        if (icon) break;
      }
      if (!icon) return;
      var href = icon.getAttribute && icon.getAttribute('href');
      // Se for link explícito pra /cart sem hash, deixa navegar (página completa)
      if (href && href !== '#' && href.indexOf('/cart') === 0 && href.indexOf('#') === -1) {
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
    }, true);

    // Defesa em profundidade: se o cart antigo abrir mesmo assim, escondemos via JS.
    // Observa mudanças no body class (cart-ajax.js adiciona 'side_Drawer_open' ao abrir)
    if ('MutationObserver' in window) {
      var bodyObserver = new MutationObserver(function () {
        if (document.body.classList.contains('side_Drawer_open')) {
          var oldDrawer = document.querySelector('#mini__cart, [data-side-drawer].mini_cart');
          if (oldDrawer) {
            oldDrawer.style.display = 'none';
            document.body.classList.remove('side_Drawer_open');
            // Se já temos cart aberto, ignora. Senão, abre o nosso.
            var root = getRoot();
            if (root && !root.classList.contains('is-open')) open();
          }
        }
      });
      bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function init() {
    // interceptCartIcons() é crítico — precisa estar pronto antes do user clicar no header.
    // wire() pode esperar (só executa quando o drawer é aberto pela 1ª vez).
    interceptCartIcons();
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(wire, { timeout: 2000 });
    } else {
      setTimeout(wire, 0);
    }

    // Pre-warm EAGER do checkout Yampi se o cart já tem itens no page load.
    // Lê do markup do header ([data-cart-count] no theme.minimal/.liquid) pra
    // detectar sem fazer request extra. Dispara load() (que internamente chama
    // warmCheckout) em idle, ANTES do user nem chegar no drawer. Resultado:
    // se user vier de carrinho com itens e clicar direto em checkout, URL já
    // tá cacheada → redirect quase instantâneo.
    function pageLoadPrewarm() {
      var countEl = document.querySelector('[data-cart-count]');
      var hasItems = false;
      if (countEl) {
        var n = parseInt(countEl.textContent || '0', 10);
        hasItems = !isNaN(n) && n > 0;
      }
      if (hasItems) load();
    }
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(pageLoadPrewarm, { timeout: 3000 });
    } else {
      setTimeout(pageLoadPrewarm, 500);
    }
  }

  // Expor API global pra outros scripts (diagnostic.js usa pjSideCart.addItem + open)
  window.pjSideCart = {
    open: open,
    close: close,
    addItem: addItem,
    load: load
  };

  // init() roda direto no DOMContentLoaded — interceptCartIcons é crítico,
  // wire() é deferido internamente via requestIdleCallback.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
